var _rect, _rect2, _circle, _rect3, _rect4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 39,
    viewBox: "0 0 60 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 9.19238,
    width: 12,
    height: 41,
    transform: "rotate(-45 0.707107 9.19238)",
    stroke: "url(#paint0_linear_458_993)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.707107,
    width: 12,
    height: 41,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 58.6288 8.69238)",
    stroke: "url(#paint1_linear_458_993)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 29,
    r: 10,
    fill: "url(#paint2_radial_458_993)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.44828,
    width: 4.88549,
    height: 4.88549,
    transform: "matrix(0.70582 -0.708391 0.70582 0.708391 24.1179 31.4678)",
    stroke: "url(#paint3_linear_458_993)",
    strokeWidth: 4.88549
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9483,
    y: 29,
    width: 2.87349,
    height: 2.87349,
    transform: "rotate(-45 27.9483 29)",
    fill: "#EDDBAC",
    stroke: "url(#paint4_linear_458_993)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_993",
    x1: 12.4762,
    y1: -170.538,
    x2: -89.4417,
    y2: 49.4692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_458_993",
    x1: 12.4762,
    y1: -179.73,
    x2: -89.4417,
    y2: 40.2769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_458_993",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30 29) rotate(90) scale(10)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB9F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_458_993",
    x1: 9.49161,
    y1: -30.2359,
    x2: 2.58244,
    y2: 16.4007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_458_993",
    x1: 31.004,
    y1: 17.0136,
    x2: 28.265,
    y2: 35.5017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArr);
export default __webpack_public_path__ + "static/media/down_arr.88de52d61ce671d5e9ea8234cfac72eb.svg";
export { ForwardRef as ReactComponent };